import french from 'date-fns/locale/fr';
import spanish from 'date-fns/locale/es';
import arab from 'date-fns/locale/ar';
import english from 'date-fns/locale/en-US';

const dateInputLanguage = (lCode) => {
    switch (lCode) {
        case 'en':
            return english;
        case 'fr':
            return french;
        case 'ar':
            return arab;
        default:
            return spanish;
    }
};

export default dateInputLanguage;
